import { render, staticRenderFns } from "./TermDispAnnouncementEditor.vue?vue&type=template&id=87a39656"
import script from "./TermDispAnnouncementEditor.vue?vue&type=script&lang=js"
export * from "./TermDispAnnouncementEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports